<template>
  <div
    class="view-angle-toggle-switcher-parts"
    :class="`view-angle-toggle-switcher-parts--${screenOrientationType}`"
  >
    <button
      class="view-angle-toggle-switcher-parts__toggle-switcher"
      :class="{ disabled: !angleSwitchEnabled }"
      @click="toggleViewAngle('race')"
    >
      <span
        class="view-angle-toggle-switcher-parts__button"
        :class="{
          'view-angle-toggle-switcher-parts__button--current':
            viewAngleStatus === 'race' && !mapViewEnabled,
        }"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 3H15.0308C14.5719 3 14.1719 3.3123 14.0606 3.75746L13.5 6H16.4692C16.9281 6 17.3281 5.6877 17.4394 5.24254L18 3Z"
            fill="white"
          />
          <path
            d="M13.5 6H10.5308C10.0719 6 9.67193 6.3123 9.56063 6.75746L9 9H11.9692C12.4281 9 12.8281 8.6877 12.9394 8.24254L13.5 6Z"
            fill="white"
          />
          <path
            d="M9 9H6.03078C5.57191 9 5.17193 9.3123 5.06063 9.75746L4.5 12H7.46922C7.92809 12 8.32807 11.6877 8.43936 11.2425L9 9Z"
            fill="white"
          />
          <path
            d="M17 9H14.0308C13.5719 9 13.1719 9.3123 13.0606 9.75746L12.5 12H15.4692C15.9281 12 16.3281 11.6877 16.4394 11.2425L17 9Z"
            fill="white"
          />
          <path
            d="M12.5 12H9.53078C9.07191 12 8.67193 12.3123 8.56063 12.7575L8 15H10.9692C11.4281 15 11.8281 14.6877 11.9394 14.2425L12.5 12Z"
            fill="white"
          />
          <path
            d="M4.5 12H1.53078C1.07191 12 0.671926 12.3123 0.560634 12.7575L0 15H2.96922C3.42809 15 3.82807 14.6877 3.93937 14.2425L4.5 12Z"
            fill="white"
          />
          <path
            d="M10.5 3H7.53078C7.07191 3 6.67193 3.3123 6.56063 3.75746L6 6H8.96922C9.42809 6 9.82807 5.6877 9.93936 5.24254L10.5 3Z"
            fill="white"
          />
          <path
            d="M6 6H3.03078C2.57191 6 2.17193 6.3123 2.06063 6.75746L1.5 9H4.46922C4.92809 9 5.32807 8.6877 5.43937 8.24254L6 6Z"
            fill="white"
          />
        </svg>
        <span class="view-angle-toggle-switcher-parts__button-label">{{
          $tc('RaceVideoPage.controller.broadcasting')
        }}</span>
      </span>

      <span
        class="view-angle-toggle-switcher-parts__button"
        :class="{
          'view-angle-toggle-switcher-parts__button--current':
            viewAngleStatus === 'player' && !mapViewEnabled,
        }"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17 11.0878C18.5 7.08783 16 0.5 10 0.5C5.57106 0.5 3.72487 2.43953 2.27172 5.49456C1.79401 6.49887 1.35878 7.62373 0.888227 8.83987C0.620375 9.53214 0.341079 10.254 0.0359911 11L0 11.0878V13.5L2 16H14L17 11.0878ZM3.67381 6.03982C3.46722 6.46773 3.2634 6.93282 3.05498 7.43762C2.80329 8.04723 2.55319 8.6936 2.28408 9.38911L2.28406 9.38916L2.26969 9.4263C2.07483 9.92991 1.87085 10.4567 1.65378 11H6.2759C6.74377 11 7.19684 10.836 7.55627 10.5364L10 8.5L3.67381 6.03982ZM13 9C13 9.55229 12.5523 10 12 10C11.4477 10 11 9.55229 11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9Z"
            fill="white"
          />
        </svg>
        <span class="view-angle-toggle-switcher-parts__button-label">{{
          $tc('RaceVideoPage.controller.onboard')
        }}</span>
      </span>
      <span class="view-angle-toggle-switcher-parts__circle-icon">
        <switch-icon />
      </span>
    </button>

    <button
      @click="toggleViewAngle('gps')"
      class="view-angle-toggle-switcher-parts__button view-angle-toggle-switcher-parts__button--map"
      :class="{ 'view-angle-toggle-switcher-parts__button--current': mapViewEnabled }"
    >
      <svg
        width="42"
        height="16"
        viewBox="0 0 42 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_15683_185663)">
          <path
            d="M37.4624 1.93899C35.8811 1.93899 34.6137 3.17711 34.5779 4.75847C34.5646 5.36957 34.4918 5.90129 34.3735 6.34997C32.7674 2.12551 25.6509 0.724845 25.3113 0.661251L24.1665 0.445312V2.33226C22.1563 2.64903 20.6096 4.37862 20.6096 6.47562V6.61105C20.2165 6.74159 19.9509 6.8465 19.8172 6.90302C17.4419 6.08882 15.1258 6.15005 13.3695 6.32569C7.40139 6.92353 1.97175 12.0476 1.74355 12.2655L0 13.9298H8.78191C9.55338 14.9096 10.736 15.5517 12.0767 15.5517C13.4173 15.5517 14.5999 14.9096 15.3714 13.9298H30.4458C31.2172 14.9096 32.3998 15.5517 33.7405 15.5517C36.0612 15.5517 37.9499 13.663 37.9499 11.3423C37.9499 9.81297 37.1221 8.48462 35.8993 7.74709C36.2661 6.96461 36.4829 5.99446 36.5091 4.80089C36.5204 4.27943 36.9391 3.87017 37.4624 3.87017H40.0688V11.8515H38.9401V13.7827H42V1.93899H37.4624ZM33.7405 13.6205C32.4845 13.6205 31.4623 12.5984 31.4623 11.3423C31.4623 10.0853 32.4845 9.06315 33.7405 9.06315C34.9966 9.06315 36.0187 10.0853 36.0187 11.3423C36.0187 12.5983 34.9966 13.6205 33.7405 13.6205ZM24.1665 4.30431V5.78536C23.58 5.8746 23.0552 5.97543 22.5809 6.07916C22.7312 5.22977 23.3533 4.54983 24.1665 4.30431ZM12.0766 13.6205C10.8206 13.6205 9.79842 12.5983 9.79842 11.3423C9.79842 10.0853 10.8206 9.06314 12.0766 9.06314C13.3327 9.06314 14.3549 10.0853 14.3549 11.3423C14.3549 12.5983 13.3327 13.6205 12.0766 13.6205ZM5.10902 11.9986C5.9198 11.3998 6.93815 10.7236 8.07384 10.1061C7.9519 10.4996 7.86721 10.9093 7.86721 11.3423C7.86721 11.567 7.89945 11.7833 7.93358 11.9986H5.10902ZM16.2197 11.9986C16.2538 11.7833 16.2861 11.567 16.2861 11.3423C16.2861 10.0674 15.7045 8.93695 14.8066 8.16424C17.8966 8.05055 20.2216 8.76875 22.2221 10.4389C22.9699 11.0632 23.7337 11.5771 24.4805 11.9986L16.2197 11.9986ZM23.4593 8.95658C23.0866 8.64534 22.7081 8.374 22.3273 8.12641C23.7329 7.76926 25.9244 7.37899 28.8154 7.37899V5.44778C27.8322 5.44778 26.9295 5.49198 26.0977 5.56176V2.8282C28.403 3.45981 31.9678 4.92973 32.6501 7.2933C30.8596 7.77739 29.5311 9.40031 29.5311 11.3423C29.5311 11.5171 29.5619 11.6835 29.5827 11.8528C28.2439 11.5868 25.7433 10.8638 23.4593 8.95658Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_15683_185663">
            <rect width="42" height="15.1064" fill="white" transform="translate(0 0.445312)" />
          </clipPath>
        </defs>
      </svg>

      <span class="view-angle-toggle-switcher-parts__button-label">{{
        $tc('RaceVideoPage.controller.circuitMode')
      }}</span>
    </button>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import SwitchIcon from '@/components/RaceVideoPage/RaceVideoPane/parts/icons/SwitchIcon.vue'

/**
 * レース動画再生画面 動画プレーヤー 表示アングルスウィッチャー コンポーネント
 */
export default defineComponent({
  name: 'ViewAngleToggleSwitcherParts',
  components: { SwitchIcon },
  props: {
    /**
     * 表示アングル
     * data: 'race' or 'player'
     */
    viewAngle: {
      type: String,
      default: 'race',
    },
    /**
     * 中継映像とオンボード映像の切り替えボタンを押下可能にするかどうか
     */
    angleSwitchEnabled: {
      type: Boolean,
      default: true,
    },
    /**
     * MAP表示フラグ
     */
    mapViewEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
  },
  setup(props) {
    const viewAngleStatus = computed(() => props.viewAngle)

    return {
      viewAngleStatus,
    }
  },
  methods: {
    /**
     * 表示アングル変更
     * @param angle: 'race' or 'player' or 'gps'
     */
    toggleViewAngle(angle: 'race' | 'player' | 'gps'): void {
      if (angle !== 'gps') {
        this.$emit('viwAngleChange', this.viewAngle === 'race' ? 'player' : 'race')
      } else {
        this.$emit('viewMapMode')
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.view-angle-toggle-switcher-parts {
  display: flex;
  gap: 4px;
  width: 252px;

  &__toggle-switcher {
    position: relative;
    display: flex;
    flex-shrink: 0;
    width: 180px;
    border-radius: 44px;
    overflow: hidden;
    background: rgba(145, 145, 145, 0.3);
    backdrop-filter: blur(12px);

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }

  &__button {
    display: flex;
    gap: 4px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 53px;
    background: transparent;

    svg {
      width: 24px;
      height: 24px;

      path {
        fill: rgba($white, 80%);
      }
    }

    &-label {
      font-size: 10px;
      line-height: 1.2;
      color: $white;
      letter-spacing: 0.02em;
      white-space: pre-wrap;
      text-align: center;
    }

    &--current {
      background: $green-light;

      svg path {
        fill: $black;
      }

      .view-angle-toggle-switcher-parts__button-label {
        color: #000;
      }

      &.view-angle-toggle-switcher-parts__button--map {
        background: linear-gradient(
            90deg,
            rgba(125, 46, 163, 0.7) 0%,
            rgba(202, 140, 232, 0.7) 72.52%,
            rgba(125, 46, 163, 0.7) 107.1%
          ),
          #000;

        svg {
          opacity: 1;

          path {
            fill: $white;
          }
        }

        .view-angle-toggle-switcher-parts__button-label {
          color: $white;
        }
      }
    }

    &--map {
      flex-shrink: 0;
      width: 68px;
      border-radius: 4px;
      background: rgba(144, 144, 144, 0.3);
      backdrop-filter: blur(6px);

      svg {
        width: 42px;
        height: 15px;
        opacity: 0.8;
      }

      .view-angle-toggle-switcher-parts__button-label {
        font-size: 10px;
      }
    }
  }

  &__circle-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    background-color: rgba(#fff, 0.8);
    border-radius: 50%;
    pointer-events: none;
    backdrop-filter: blur(6px);
    transform: translate(-50%, -50%);

    svg {
      width: 18px;
      height: 18px;
    }
  }

  &--landscape-primary,
  &--landscape-secondary {
    @media screen and (max-width: 710px) {
      width: 234px;

      .view-angle-toggle-switcher-parts {
        &__toggle-switcher {
          width: 160px;
        }
      }
    }
  }
}
</style>
